import { Component, ViewChild} from '@angular/core';
import { BzgToastService, BzgModalService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { ConnectEcmService } from '../core/connect-ecm.service';
import { ConnectEcmFoldersComponent } from './connect-ecm-folders/connect-ecm-folders.component';
import { PendingChangesConnectAlertComponent } from '../modal-actions/connect-pendingchanges.component';
import { ConnectEcmPropertiesComponent } from './connect-ecm-properties/connect-ecm-properties.component';
import { async } from 'q';
import { IConnectRepositoryFolder } from '../core/IConnectRepositoryFolder';
import { IConnectRepository } from '../core/IConnectRepository';
import { IExternalSystem } from '../core/IExternalSystem';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'connect-ecm',
    templateUrl: 'connect-ecm.component.html',
    styleUrls: ['connect-ecm.component.scss']
})
export class ConnectEcmComponent {
    @ViewChild('ecmFolders', { static: false}) ecmFolders: ConnectEcmFoldersComponent;
    @ViewChild('propertiesForm', { static: false}) propertiesForm: ConnectEcmPropertiesComponent;
    public selectedFolder: IConnectRepositoryFolder;
    public externalSystems: IExternalSystem[];
    public selectedRepository: IConnectRepository;
    public selectedExternalSystem: IExternalSystem;
    public showLoading: boolean;
    public ecmMetadata;
    public prevSelectedRepository: IConnectRepository;
    public isBusy: boolean;
    public selectedTab: number = 0;
    alert_change_data:string;

    constructor(private _toastService: BzgToastService, private _modalService: BzgModalService,
        private _translateService: TranslateService, private _connectEcmService: ConnectEcmService,
        private _i18nService: I18nService, private _showToastService: ShowToastService) { }

    async ngOnInit() {
        this.ecmMetadata = await this._connectEcmService.getMetadata();
        this._connectEcmService.getExternalSystems().subscribe((data) => {
            this.externalSystems = data;
        });

        this._translateService.get('ECM.CHANGE_DATA_CONFIGURACION').subscribe(translation => {
            this.alert_change_data = translation;
          });
    }

    async selectRepository(repository: IConnectRepository) {
        this.isBusy = true;
        if (this.prevSelectedRepository && this.selectedRepository) {
            if (!_.isEqual(this.prevSelectedRepository, this.selectedRepository)) {
                this._showPendingChangesDialog(async () => {
                    await this.applyChanges();
                    this.setSelectedRepositoryPrev(repository);
                }, () => {
                    this.setSelectedRepositoryPrev(repository);
                }, "");
            } else {
                this.setSelectedRepositoryPrev(repository);
            }
        } else {
            this.setSelectedRepositoryPrev(repository);
        }

        this.isBusy = false;
    }

    public cancelChanges() {
        this.selectedRepository = _.cloneDeep(this.prevSelectedRepository);
        if (this.ecmFolders) {
            this.ecmFolders.loadFolders();
        }
    }

    saveChanges() {
        if (this.propertiesForm.isValid()) {
            this._showPendingChangesDialog(async () => {

                await this.applyChanges();
            }, () => {
            }, this.alert_change_data);
        }else{
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.REQUIRED_FIELDS'), 'error');
        }
    }

    async applyChanges() {        
        if (this.propertiesForm.isValid()) {
            this.showLoading = true;
            const modifiedFolders = this.ecmFolders.getFoldersToSave();
            await this._connectEcmService.updateRepository(_.cloneDeep(this.selectedRepository));

            if (modifiedFolders) {
                Object.keys(modifiedFolders).map(async (key) => {
                    await this._connectEcmService.updateFolder(modifiedFolders[key], key);
                });
            }

            this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
            this.showLoading = false;
        } else {
            this._showToastService.showToast(this._i18nService.instant('GLOBAL.INVALID_FORM'), 'error');
        }
    }

    private async setSelectedRepositoryPrev(repository) {
        this.selectedRepository = await this._connectEcmService.getRepository(repository.id).toPromise();
        this.selectedRepository.id = repository.id;
        this.selectedRepository.nodes = repository.nodes;
        this.prevSelectedRepository = _.cloneDeep(this.selectedRepository);
        if (this.ecmFolders) {
            this.ecmFolders.loadFolders();
        }
    }

    private _showPendingChangesDialog(saveAction: Function, cancelAction: Function, message:string) {
        const modal = this._modalService.open(PendingChangesConnectAlertComponent,
            {
                closeOnBackdropClick: false, 
                closeOnRouterNavigation: true, 
                data: {
                    message: message
                }
            });
        modal.afterClosed().subscribe((result: string) => {
            if (result === 'save') {
                saveAction();
            } else {
                cancelAction();
            }
        });
    };

    public reloadFolders() {
        if (this.ecmFolders) {
            this.ecmFolders.loadFolders();
        }
    }
}
